import { FC } from 'react'

import { styled } from 'styled-components'

import withLabel from 'admin/decorators/withLabel/withLabel'

const ContentArea = styled.div`
  position: relative;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 16px;
`

const FormSection: FC<{ children?: any; label?: string }> = (props) => {
  const { children } = props

  return <ContentArea>{children}</ContentArea>
}

const $FormSection = withLabel(FormSection)

export default $FormSection
